// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { getDetailImage } from "~/util/cdn";
import { deferPromise } from "~/util/general";

export default class Photo extends Content {
	getPosterData() {
		return this._promiseData.promise;
	}

	_build() {
		this._dom.container.classList.add("content-photo");

		var photo = this._data.best.urls["default"] ? this._data.best.urls["default"] : null;
		// * libovolna vyska
		const src = photo ? getDetailImage(photo, true) : "";

		/* trida image-holder je jen proto, aby se k nam nepridalo panorama */
		var pic = node("img", {alt: "", src: src, className: "image-holder", crossOrigin: "anonymous" });
		/* trida bestimage je jen proto, aby tam detail umel vrazit tlacitka na pano/3d */
		var container = node("div");
		var link = node("a", {href: this._data.href, target: "_blank"});

		link.appendChild(pic);
		this._dom.container.appendChild(link);

		this._promiseData = deferPromise();
		this._promiseData.resolve([this._dom.container, "photo"]);
	}
}
